module.exports = __webpack_public_path__ + "img/banner.7dbf9916.png";